import { render, staticRenderFns } from "./BalanceHistoryTable.vue?vue&type=template&id=2a8dbaaa&scoped=true"
import script from "./BalanceHistoryTable.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dbaaa",
  null
  
)

export default component.exports